import PropTypes from 'prop-types';
import React from 'react';
import { Statistics } from '@weezevent/nacre';

const StatisticsTable = ({ statistics = null, rows = null, className = '' }) => {
    const filteredRows = React.useMemo(() => {
        let tableData = [];

        if (!statistics) {
            return tableData;
        }

        Object.entries(rows).forEach(([key, row]) => {
            if (statistics?.[key] && statistics[key] > 0) {
                tableData.push(row);
            }
        });

        return tableData;
    }, [statistics, rows]);

    if (filteredRows.length === 0) {
        return null;
    }

    return <Statistics.Table data={filteredRows} className={className} />;
};

StatisticsTable.propTypes = {
    statistics: PropTypes.object,
    rows: PropTypes.object,
    className: PropTypes.string
};

export default StatisticsTable;
